import React from "react";
import { useTranslation } from 'react-i18next';
import { useAuth } from "../../hooks/auth";
import PartNumberApi from "../../services/PartNumberApi";
import Select from "./Select";

export interface PartNumber {
  partnumberID: number;
  bomCompanyCode: number;
  partnumberCode: string;
  name: string;
}

type ComboProps = any;
function groupBy(items: any) {
  return items.reduce((acc: any, curr: any) => {
    if (curr.status?.posicao) {
      const { posicao } = curr.status;
      const currentItems = acc[posicao];
  
      return { 
        ...acc,
        [posicao]: currentItems ? [...currentItems, curr] : [curr]
      };
    }
    return acc;
  }, {});
}
const SelectPartNumber: React.FC<ComboProps> = ({ name, control, multiple, defaultValue, style, serviceType, label, onChange, groupItens, companyBOMCode, ...props}) => {
  const { user } = useAuth();
  const { t: _t } = useTranslation("General");
   

  const handleSearch = async(val: any) => {
    companyBOMCode = companyBOMCode === undefined ? user.company.companyBOMCode : companyBOMCode;
    return await PartNumberApi.search(companyBOMCode, val)
    .then(result => {
      const filteredList: PartNumber[] = [];

      result.data.items.forEach((item: PartNumber) => {
        if (groupItens){
          if (!filteredList.some((x: PartNumber) => x.partnumberCode === item.partnumberCode))
            filteredList.push(item)
        }
        else
          filteredList.push(item)
      });

      let lista = filteredList.map((reg: PartNumber) => {
        return { 
            label: reg.partnumberCode + " - " + reg.name, 
            code: reg.partnumberID,
            name: reg.name,
            partnumberCode: reg.partnumberCode,
            bomCompanyCode: reg.bomCompanyCode
        };
      });

      return lista;
    })
  }

  return (
    <Select 
      {...props}
      onChange={onChange}
      allowSelectValueNotFound={false}
      label={label} 
      name={name}
      control={control} 
      options={[]}
      style={style}
      searchFunction={handleSearch}
      defaultValue={defaultValue}
      multiple={multiple}
      />
  )
}

export default SelectPartNumber;
